<template>
  <empty-modal>
    <template v-slot:modal-title>Выберите тип заказа</template>
    <template v-slot:modal-body>
      <div class="create-order-btns">
        <a
          v-for="(el, i) of layout.orderTypes"
          :key="i"
          @click.prevent="setDeliveryType(el.isBuyout)"
          @keypress="setDeliveryType(el.isBuyout)"
          class="btn"
        >
          <img :src="`/images/${el.imgUrl}`" alt="order-image" />
          <div class="text-block">
            <div class="text-block-header">{{ el.title }}</div>
            <div class="description">{{ el.subTitle }}</div>
          </div>
        </a>
      </div>
    </template>
  </empty-modal>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import EmptyModal from '@components/EmptyModal.vue'

export default {
  name: 'ChooseFormModal',
  components: { EmptyModal },
  computed: {
    ...mapState(GENERAL_STORE, ['layout', 'base']),
    ...mapGetters(GENERAL_STORE, ['isAnonimousForm']),
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['updateBuyout', 'updateformVersion']),
    ...mapActions(GENERAL_STORE, ['getCheckPrint', 'resetServices']),
    setDeliveryType(isBuyout) {
      if (this.base.isBuyout === undefined) {
        this.updateForm(isBuyout)
        this.getCheckPrint()
        // без сервисов потому что и так установились изначально в setInitialState
        this.$emit('onChosen')
      } else {
        this.updateForm(isBuyout)
        this.resetServices()
        this.getCheckPrint()
        this.$emit('onChosen')
      }
    },
    updateForm(isBuyout) {
      if (isBuyout) {
        this.updateBuyout(true)
        this.updateformVersion(this.isAnonimousForm ? 4 : 2)
      } else {
        this.updateBuyout(false)
        this.updateformVersion(this.isAnonimousForm ? 3 : 1)
      }
    },
  },
}
</script>
